module.exports = __webpack_public_path__ + "static/media/1_8.1fe05eea.png";